import { Risk } from '@/Components/Risks/Risk';
import { format } from 'date-fns';
import { dateformat } from '@/utils/GlobalConstants';
import { AcknowledgedIcon, DashboardIcon, SeenIcon, StatusReportIcon } from '@/Components/ui/Icons/TooltipIcon';
import { getRatingColor, getStatusColor } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';
import { useResponsiveZoom } from '@/hooks/use-responsive-zoom';

interface RiskPopupProps {
    risk: Risk;
}

const RiskPopup = ({ risk }: RiskPopupProps) => {
    const isMobile = useIsMobile();
    const responsiveZoom = useResponsiveZoom();

        if(isMobile) {
            return (
                <div className='flex flex-col w-full text-2xl'>
                <div className='flex flex-row mb-4'><div className="w-48 font-semibold">Work Package:</div><div>{risk.workPackage}</div><div className='flex flex-row my-auto px-2'>{risk.displayOnStatusReport ? <StatusReportIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}{risk.displayOnDashboard ? <DashboardIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}</div></div>
                <div className='flex flex-col gap-4 mb-4'>
                    <div className='flex flex-row'><div className="w-48 font-semibold">Raised By: </div> {risk.raisedBy ? risk.raisedBy : "N/A"} - {format(new Date(risk.date), dateformat)}</div>
                    <div className='flex flex-row'><div className="w-48 font-semibold">Owner: </div><div>{risk.owner}</div><div className='flex flex-row my-auto px-2 space-x-2'>{risk.seen ? <SeenIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}{risk.acknowledged ? <AcknowledgedIcon className="w-8 h-8" /> : <div className="w-8 h-8" />}</div></div>
                    <div className='flex flex-row'><div className="w-48 font-semibold">Status: </div><div className={'w-48 text-center ' + getStatusColor(risk.status)}>{risk.status}</div></div>
                    <div className="flex flex-row"><div className="w-48 font-semibold">Probability:</div> <div className={'w-48 text-center ' + getRatingColor(risk.probability as "High" | "Medium" | "Low")}>{risk.probability}</div></div>
                    <div className="flex flex-row"><div className="w-48 font-semibold">Impact:</div>      <div className={'w-48 text-center ' + getRatingColor(risk.impact as "High" | "Medium" | "Low")}>{risk.impact}</div></div>
                    <div className="flex flex-row"><div className="w-48 font-semibold">Rating:</div>      <div className={'w-48 text-center ' + getRatingColor(risk.rating as "High" | "Medium" | "Low")}>{risk.rating}</div></div>
                </div>
                <div className='mb-4'>
                    <div className='font-semibold'>Risk:</div>
                    <div>{risk.risk}</div>
                </div>
                <div className='mb-4'>
                    <div className='font-semibold'>Mitigation:</div>
                    <div>{risk.mitigation}</div>
                </div>
                <div className='mb-4'>
                    <div className='font-semibold'>Notes:</div>
                    <div>{risk.notes && risk.notes}</div>
                </div>
            </div>
        )
    }

    return (
        <div className='flex flex-col gap-4' style={{zoom: responsiveZoom}}>
            <div className='flex flex-row'><div>Work Package:</div><div className='px-2'>{risk.workPackage}</div><div className='flex flex-row my-auto px-2'>{risk.displayOnStatusReport ? <StatusReportIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}{risk.displayOnDashboard ? <DashboardIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}</div></div>
            <div className='flex flex-row my-4 justify-between'>
                <div className='flex flex-col gap-4 mr-8'>
                    <div className='flex flex-row'><div className="w-24">Raised By: </div> {risk.raisedBy} - {format(new Date(risk.date), dateformat)}</div>
                    <div className='flex flex-row'><div className="w-24">Owner: </div><div>{risk.owner}</div><div className='flex flex-row my-auto px-2 space-x-2'>{risk.seen ? <SeenIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}{risk.acknowledged ? <AcknowledgedIcon className="w-4 h-4" /> : <div className="w-4 h-4" />}</div></div>
                    <div className='flex flex-row'><div className="w-24">Status: </div><div className={'w-24 text-center ' + getStatusColor(risk.status)}>{risk.status}</div></div>
                </div>
                <div className='flex flex-col gap-4'>
                    <div className="flex flex-row"><div className="w-24">Probability:</div> <div className={'w-24 text-center ' + getRatingColor(risk.probability as "High" | "Medium" | "Low")}>{risk.probability}</div></div>
                    <div className="flex flex-row"><div className="w-24">Impact:</div>      <div className={'w-24 text-center ' + getRatingColor(risk.impact as "High" | "Medium" | "Low")}>{risk.impact}</div></div>
                    <div className="flex flex-row"><div className="w-24">Rating:</div>      <div className={'w-24 text-center ' + getRatingColor(risk.rating as "High" | "Medium" | "Low")}>{risk.rating}</div></div>
                </div>
            </div>
            <div>
                <div>Risk:</div>
                <div>{risk.risk}</div>
            </div>
            <div>
                <div>Mitigation:</div>
                <div>{risk.mitigation}</div>
            </div>
            <div>
                <div>Notes:</div>
                <div>{risk.notes && risk.notes}</div>
            </div>
        </div>
    )
}

export default RiskPopup